export default __webpack_public_path__ + "static/matteo-cfb35afc3bc049484d28e90287063623.png";